import { Injectable } from '@angular/core';
import { decodeJwt } from 'jose';
import { isPast, fromUnixTime } from 'date-fns';
import { OptoutPayloadSchema, type OptoutJwtTokenPayload } from '../models/jwtToken.interface';
import { Brand } from '../models/brand.enum';

export type TokenResult =
  | { success: true; payload: OptoutJwtTokenPayload; brand: Brand }
  | { success: false; error: 'invalid' | 'expired'; brand: Brand };

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  processToken(token: string): TokenResult {
    try {
      const decoded = decodeJwt(token);
      const brand = this.extractBrand(decoded.brand);

      const result = OptoutPayloadSchema.safeParse(decoded);
      if (!result.success) {
        return { success: false, error: 'invalid', brand };
      }

      if (decoded.exp && isPast(fromUnixTime(decoded.exp))) {
        return { success: false, error: 'expired', brand };
      }

      return { success: true, payload: result.data, brand };
    } catch {
      return { success: false, error: 'invalid', brand: Brand.ESSENT };
    }
  }

  private extractBrand(brandClaim: unknown): Brand {
    if (!brandClaim || typeof brandClaim !== 'string') return Brand.ESSENT;

    const brandValue = brandClaim.toLowerCase();
    return Object.values(Brand).find((b) => b === brandValue) ?? Brand.ESSENT;
  }
}
